import * as React from 'react';

import { useNavigate } from 'react-router-dom';
// redux
import { AppDispatch, RootState } from '../../store';
import { ModuloState, setModulo } from '../../store/slices/modulo';
import { useDispatch, useSelector } from 'react-redux';
// mui components
import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton, Tooltip } from '@mui/material';
// mui icons
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';


const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

type Props = {
  modulo: ModuloState
  mid: string
  openEditar: boolean
  setOpenEditar: any
  openEliminar: boolean
  setOpenEliminar: any
}

export default function MenuModulos({modulo, mid, openEditar, setOpenEditar, openEliminar, setOpenEliminar}: Props) {

  const dispatch = useDispatch<AppDispatch>();

  const { modulos } = useSelector((state: RootState) => state.modulo);
  const { curso } = useSelector((state: RootState) => state.curso);

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEliminarModulo = () => {
    setOpenEliminar(true)
    const moduloEliminar = modulos.find(item => item.modulo === modulo.modulo);
    navigate(`/curso/${curso?.sigla}/${modulo.modulo}`);
    dispatch(setModulo(moduloEliminar));
    handleClose()
  }

  const handleEditarModulo = () => {
    setOpenEditar(true)
    const moduloEditar = modulos.find(item => item.modulo === modulo.modulo);
    navigate(`/curso/${curso?.sigla}/${modulo.modulo}`);
    dispatch(setModulo(moduloEditar))
    handleClose()
  }
  
  return (
    <div>
      <Tooltip title="Menú Módulo">
        <IconButton
          onClick={handleClick}
          sx={{color: 'white'}}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEditarModulo} disableRipple>
          <EditIcon />
          Editar
        </MenuItem>
        <MenuItem onClick={handleEliminarModulo} disableRipple>
          <DeleteIcon />
          Eliminar
        </MenuItem>
      </StyledMenu>
    </div>
  );
}